require('@progress/kendo-angular-intl/locales/ar-BH/calendar');
require('@progress/kendo-angular-intl/locales/ar-BH/numbers');
require('@progress/kendo-angular-intl/locales/ar-JO/calendar');
require('@progress/kendo-angular-intl/locales/ar-JO/numbers');
require('@progress/kendo-angular-intl/locales/ar-SA/calendar');
require('@progress/kendo-angular-intl/locales/ar-SA/numbers');
require('@progress/kendo-angular-intl/locales/bg/calendar');
require('@progress/kendo-angular-intl/locales/bg/numbers');
require('@progress/kendo-angular-intl/locales/cs/calendar');
require('@progress/kendo-angular-intl/locales/cs/numbers');
require('@progress/kendo-angular-intl/locales/da/calendar');
require('@progress/kendo-angular-intl/locales/da/numbers');
require('@progress/kendo-angular-intl/locales/de/calendar');
require('@progress/kendo-angular-intl/locales/de/numbers');
require('@progress/kendo-angular-intl/locales/de-AT/calendar');
require('@progress/kendo-angular-intl/locales/de-AT/numbers');
require('@progress/kendo-angular-intl/locales/de-CH/calendar');
require('@progress/kendo-angular-intl/locales/de-CH/numbers');
require('@progress/kendo-angular-intl/locales/de-LI/calendar');
require('@progress/kendo-angular-intl/locales/de-LI/numbers');
require('@progress/kendo-angular-intl/locales/de-LU/calendar');
require('@progress/kendo-angular-intl/locales/de-LU/numbers');
require('@progress/kendo-angular-intl/locales/el/calendar');
require('@progress/kendo-angular-intl/locales/el/numbers');
require('@progress/kendo-angular-intl/locales/el-CY/calendar');
require('@progress/kendo-angular-intl/locales/el-CY/numbers');
require('@progress/kendo-angular-intl/locales/en/calendar');
require('@progress/kendo-angular-intl/locales/en/numbers');
require('@progress/kendo-angular-intl/locales/en-AU/calendar');
require('@progress/kendo-angular-intl/locales/en-AU/numbers');
require('@progress/kendo-angular-intl/locales/en-CA/calendar');
require('@progress/kendo-angular-intl/locales/en-CA/numbers');
require('@progress/kendo-angular-intl/locales/en-GB/calendar');
require('@progress/kendo-angular-intl/locales/en-GB/numbers');
require('@progress/kendo-angular-intl/locales/en-IE/calendar');
require('@progress/kendo-angular-intl/locales/en-IE/numbers');
require('@progress/kendo-angular-intl/locales/en-NZ/calendar');
require('@progress/kendo-angular-intl/locales/en-NZ/numbers');
require('@progress/kendo-angular-intl/locales/en-SG/calendar');
require('@progress/kendo-angular-intl/locales/en-SG/numbers');
require('@progress/kendo-angular-intl/locales/en-ZA/calendar');
require('@progress/kendo-angular-intl/locales/en-ZA/numbers');
require('@progress/kendo-angular-intl/locales/es/calendar');
require('@progress/kendo-angular-intl/locales/es/numbers');
require('@progress/kendo-angular-intl/locales/es-AR/calendar');
require('@progress/kendo-angular-intl/locales/es-AR/numbers');
require('@progress/kendo-angular-intl/locales/es-CL/calendar');
require('@progress/kendo-angular-intl/locales/es-CL/numbers');
require('@progress/kendo-angular-intl/locales/es-CO/calendar');
require('@progress/kendo-angular-intl/locales/es-CO/numbers');
require('@progress/kendo-angular-intl/locales/es-PR/calendar');
require('@progress/kendo-angular-intl/locales/es-PR/numbers');
require('@progress/kendo-angular-intl/locales/et/calendar');
require('@progress/kendo-angular-intl/locales/et/numbers');
require('@progress/kendo-angular-intl/locales/fi/calendar');
require('@progress/kendo-angular-intl/locales/fi/numbers');
require('@progress/kendo-angular-intl/locales/fr/calendar');
require('@progress/kendo-angular-intl/locales/fr/numbers');
require('@progress/kendo-angular-intl/locales/fr-BE/calendar');
require('@progress/kendo-angular-intl/locales/fr-BE/numbers');
require('@progress/kendo-angular-intl/locales/fr-CA/calendar');
require('@progress/kendo-angular-intl/locales/fr-CA/numbers');
require('@progress/kendo-angular-intl/locales/fr-CH/calendar');
require('@progress/kendo-angular-intl/locales/fr-CH/numbers');
require('@progress/kendo-angular-intl/locales/fr-LU/calendar');
require('@progress/kendo-angular-intl/locales/fr-LU/numbers');
require('@progress/kendo-angular-intl/locales/gd/calendar');
require('@progress/kendo-angular-intl/locales/gd/numbers');
require('@progress/kendo-angular-intl/locales/he/calendar');
require('@progress/kendo-angular-intl/locales/he/numbers');
require('@progress/kendo-angular-intl/locales/hu/calendar');
require('@progress/kendo-angular-intl/locales/hu/numbers');
require('@progress/kendo-angular-intl/locales/is/calendar');
require('@progress/kendo-angular-intl/locales/is/numbers');
require('@progress/kendo-angular-intl/locales/it/calendar');
require('@progress/kendo-angular-intl/locales/it/numbers');
require('@progress/kendo-angular-intl/locales/it-CH/calendar');
require('@progress/kendo-angular-intl/locales/it-CH/numbers');
require('@progress/kendo-angular-intl/locales/lt/calendar');
require('@progress/kendo-angular-intl/locales/lt/numbers');
require('@progress/kendo-angular-intl/locales/lv/calendar');
require('@progress/kendo-angular-intl/locales/lv/numbers');
require('@progress/kendo-angular-intl/locales/mt/calendar');
require('@progress/kendo-angular-intl/locales/mt/numbers');
require('@progress/kendo-angular-intl/locales/nb/calendar');
require('@progress/kendo-angular-intl/locales/nb/numbers');
require('@progress/kendo-angular-intl/locales/nl/calendar');
require('@progress/kendo-angular-intl/locales/nl/numbers');
require('@progress/kendo-angular-intl/locales/nl-BE/calendar');
require('@progress/kendo-angular-intl/locales/nl-BE/numbers');
require('@progress/kendo-angular-intl/locales/nn/calendar');
require('@progress/kendo-angular-intl/locales/nn/numbers');
require('@progress/kendo-angular-intl/locales/pl/calendar');
require('@progress/kendo-angular-intl/locales/pl/numbers');
require('@progress/kendo-angular-intl/locales/pt/calendar');
require('@progress/kendo-angular-intl/locales/pt/numbers');
require('@progress/kendo-angular-intl/locales/pt-PT/calendar');
require('@progress/kendo-angular-intl/locales/pt-PT/numbers');
require('@progress/kendo-angular-intl/locales/ro/calendar');
require('@progress/kendo-angular-intl/locales/ro/numbers');
require('@progress/kendo-angular-intl/locales/sk/calendar');
require('@progress/kendo-angular-intl/locales/sk/numbers');
require('@progress/kendo-angular-intl/locales/sl/calendar');
require('@progress/kendo-angular-intl/locales/sl/numbers');
require('@progress/kendo-angular-intl/locales/sv/calendar');
require('@progress/kendo-angular-intl/locales/sv/numbers');
require('@progress/kendo-angular-intl/locales/sv-FI/calendar');
require('@progress/kendo-angular-intl/locales/sv-FI/calendar');
require('@progress/kendo-angular-intl/locales/zh-Hans-SG/calendar');
require('@progress/kendo-angular-intl/locales/zh-Hans-SG/calendar');
